define(function (require) {

    var App = window.App || {};
    var ShortcutsManager = require('web-agent-utils/AgentShortcutsManager');
    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({
        supportShortcuts: true,

        shortcutType: ShortcutsManager.shortcutType,

        ShortcutsLPViewMap: {
            hotkeyTooltip: ".lpview_hotkey_tooltip"
        },

        registerShortcut: function (type, callback, tooltip) {
            if (type.constructor === Array) {
                for (var i = 0; i < type.length; i++) {
                    this.registerShortcut(type[i], callback, tooltip);
                }
                return;
            }

            if (window.App && window.App.agentShortcutsManager) {
                this.shortcutsByTypeMap = this.shortcutsByTypeMap || {};

                var tooltipView;
                if (this.shortcutsByTypeMap[type.type]) {
                    tooltipView = this.shortcutsByTypeMap[type.type].tooltipView;
                    if (tooltipView) {
                        tooltipView.parentNode.removeChild(tooltipView);
                        tooltipView = null;
                    }
                    window.App.agentShortcutsManager.unregister(type, this.shortcutsByTypeMap[type.type].callback, this);
                }
                if (tooltip) {
                    tooltipView = this.createHotkeyTooltip(type.shortcutChar, tooltip.target, tooltip.position);
                }
                this.shortcutsByTypeMap[type.type] = {type: type, callback: callback, tooltipView : tooltipView};
                window.App.agentShortcutsManager.register(type, callback, tooltipView, this);
            }
        },

        unregisterShortcut: function (type, callback) {
            if (type.constructor === Array) {
                for (var i = 0; i < type.length; i++) {
                    this.unregisterShortcut(type[i], callback);
                }

                return;
            }

            if (window.App && window.App.agentShortcutsManager) {
                this.shortcutsByTypeMap = this.shortcutsByTypeMap || {};
                if (this.shortcutsByTypeMap[type.type]) {
                    window.App.agentShortcutsManager.unregister(type, callback, this);
                    if (this.shortcutsByTypeMap[type.type].type.tooltipView) {
                        this.removeView(this.shortcutsByTypeMap[type.type].type.tooltipView);
                    }
                    this.shortcutsByTypeMap[type.type] = null;
                    delete this.shortcutsByTypeMap[type.type];
                }
            }
        },

        createHotkeyTooltip: function (shortcutChar, target, position) {
            if (this.supportShortcuts) {
                target = target || this.ShortcutsLPViewMap.hotkeyTooltip;
                var tooltipView = this.createView({
                    templateFile: 'LP_hotkey_tip.html',
                    target: target,
                    hidden: true,
                    textInjection: {hotkey: shortcutChar, position: position}
                });
                return tooltipView;
            }
        },

        dispose: function () {
            if (this.shortcutsByTypeMap) {
                for (var prop in this.shortcutsByTypeMap) {
                    if (this.shortcutsByTypeMap.hasOwnProperty(prop)) {
                        window.App.agentShortcutsManager.unregister(this.shortcutsByTypeMap[prop].type, this.shortcutsByTypeMap[prop].callback, this);
                    }
                }
            }
        }
    });

    // todo - what to export?

});
